import StepConnector from "@material-ui/core/StepConnector";
import { withStyles } from "@material-ui/core/styles";

export const BaseStepperStyleConnector = withStyles({
  active: {
    "& $line": {
      borderColor: "#FF7A59",
    },
  },
  completed: {
    "& $line": {
      borderColor: "#FF7A59",
    },
  },
  line: {
    height: 1,
    borderColor: "#646464",
  },
})(StepConnector);
